$(function () {

    var errorPrefix = "Error: ";

    ele.message = function () {
        return function (h) {
            var l = $(document.createElement("div"));
            l.addClass("e_responseMessage notification notification--error");
            l.html(h);
            return l
        }
    }();
    
    /* new for new ELE DOM! */
    ele.notification = function () {
        return function (message, type) {
        	if (type == undefined) type = "info";
            var l = $(document.createElement("div"));
            l.addClass("e_responseMessage notification notification--" + type);
            l.html(message);
            return l
        }
    }();

    //new password meter
    $("input[name=CustomerPassword], input[name=NewPassword], input[name=userpassword]").on("keyup change", function () {
        //if the field is blank, it wont run the password strength check so manually reset
        if ($(this).prop("value") === "") {
            $('#CustomerPasswordBreakdown').find('.validation-rule').removeClass("error").removeClass("success")
        } else {
            $(this).valid(); //run validation function
        }
    });

    // Login form  ###################################################################################################################
    $("#mainLoginForm, #loginFormBox").each(function () {
        $(this).validate({
            rules: {
                customerlogin: "required",
                customerpassword: "required"
            },
            messages: {
                customerlogin: errorPrefix + i18n('js_valid_login_username'),
                customerpassword: errorPrefix + i18n('js_valid_login_password')
            },
            errorElement: "div",
            errorPlacement: function (h, l) {
                h.insertAfter(l)
            },
            focusInvalid: false,
            invalidHandler: function(form, validator) {
                //this is for some reason called before errors are displayed, so force display
                var errors = validator.numberOfInvalids();
                if (errors) {
                    validator.showErrors();
                    //focus first visible error
                    $(":input.error:visible:first").focus();
                }
            }
        })
    });

    // Password reminder form  #######################################################################################################
    var $PasswordReminderForm = $("#PasswordReminder");
    if ($PasswordReminderForm.length > 0) {
    	$PasswordReminderForm.validate({
            rules: ele.validations.PasswordReminder.rules,
            messages: ele.validations.PasswordReminder.messages,
            errorElement: "div",
            errorPlacement: function (h, l) {
                l.parent("span").parent("li").append(h)
            }
        });
    	$PasswordReminderForm.submit(function (e) {
            e.preventDefault();
            $(this).valid() && $.post(ele.uri.buildUrl("passwordReminder"), $PasswordReminderForm.serialize(), function () {
            	$PasswordReminderForm.fadeOut("fast");
                $(".ele-forgottenPassword .e_p1")
                	.addClass("e_responseMessage")
                	.text(i18n('js_password_reset_confirm'))
                	.show();
            })
        })
    }

    // Username reminder form  #######################################################################################################
    var $UserReminderForm = $("#UsernameReminder");
    if ($UserReminderForm.length > 0) {
    	$UserReminderForm.validate({
            rules: ele.validations.PasswordReminder.rules,
            messages: ele.validations.PasswordReminder.messages
        });
    	$UserReminderForm.submit(function (e) {
            e.preventDefault();
            if ($UserReminderForm.valid()) {
                ele.handleAJAX(
                    "POST",
                    ele.uri.buildUrl("UsernameReminder"),
                    $UserReminderForm.serializeArray().reduce(function(a, x) { a[x.name] = x.value; return a; }, {})
                ).then(response => {
                    $UserReminderForm.fadeOut("fast");
                    $('.notifications').empty().append(ele.notification(i18n("js_password_reset_confirm"), 'success')).hide().fadeIn("slow");
                });
            }
        })
    }


    // Simple password reset  #######################################################################################################
    var $PasswordResetForm = $("#PasswordReset");
    if ($PasswordResetForm.length > 0) {
	    $PasswordResetForm.validate({
	        rules: {
	            customerlogin: {
	                required: true,
	                rangelength: [6, 70],
	                username: true
	            },
	            customeremail: {
	                required: true,
	                email: true,
	                maxlength: 70
	            }
	        },
	        messages: {
	            customerlogin: {
	                required: errorPrefix + i18n('js_valid_login_username'),
	                rangelength: errorPrefix + i18n('js_valid_length_range', {min: 6, max: 70})
	            },
	            customeremail: {
	                required: errorPrefix + i18n('js_valid_email'),
	                email: errorPrefix + i18n('js_valid_email_invalid'),
	                maxlength: errorPrefix + i18n('js_valid_length_max', {max: 70})
	            }
	        },
            errorElement: "div",
            errorPlacement: function (h, l) {
                h.insertAfter(l);
            }
	   	});
    }


    // Password reset challenge #######################################################################################################
    var $PasswordResetChallengeForm = $("#PasswordResetChallengeForm");
    if ($PasswordResetChallengeForm.length > 0) {
        let PasswordResetChallengeFormFunction = function (form) {
        	form.validate({
                rules: ele.validations.PasswordChallenge.rules,
                messages: ele.validations.PasswordChallenge.messages,
                errorElement: "div",
                errorPlacement: function (h, l) {
                    h.insertAfter(l);
                }
            });
            form.submit(function () {
                if (form.valid()) {
                    ele.handleAJAX(
                        "POST",
                        form.attr("action"),
                        form.serializeObject()
                    ).then(response => {
                        $PasswordResetChallengeForm.parent().fadeOut("fast", function () {
                            $('.notifications').empty().append(ele.notification(i18n("js_password_reset_confirm"), 'success')).hide().fadeIn("slow");
                        })
                    });
                }
                return false;
            });
        };
        PasswordResetChallengeFormFunction($PasswordResetChallengeForm)
    }


    // Advanced password reset form #######################################################################################################
    $('document').ready(function(){ // some kind of race condition in ELE I cannot locate which is solved by calling this earlier in the function
        var $PasswordResetFormComplex = $("#PasswordResetForm");
        var validations = ele.validations;
        if ($PasswordResetFormComplex.length > 0) {
            let PasswordResetFormFunction =
                function (form) {
                    form.validate({
                        rules: validations.customer.rules,
                        messages: validations.customer.messages,
                        errorElement: "div",
                        errorPlacement: function (h, l) {
                            l.parent(".formGroup__inputContainer").append(h);
                        }
                    });

                    form.submit(function (e) {
                        e.preventDefault();
                        if (form.valid()) {
                            ele.handleAJAX(
                                "POST",
                                form.attr("action"),
                                form.serializeObject()
                            ).then(response => {
                                $PasswordResetFormComplex.fadeOut("fast", function () {
                                    $('.ele-forgottenPassword').addClass('success');
                                    $('.notifications').empty().append(ele.notification(i18n("js_password_reset_changed"), 'success')).hide().fadeIn("slow");
                                    $('#continue_message').html('<a class="e_btn btn continue_button" href="' + ele.uri.buildUrl(response.destination) + '">Continue</a>').hide().fadeIn("slow");
                                });
                            });
                        }
                    });

                    if (form.find("#Customerdob")) {
                        form.find("#Customerdob").datepicker({
                            dateFormat: "dd/mm/yy",
                            changeMonth: true,
                            changeYear: true,
                            showOtherMonths: true,
                            minDate: new Date(1900, 0, 1),
                            yearRange: '1900:c'
                        });
                    }
                };
            PasswordResetFormFunction($PasswordResetFormComplex);
        }
    });
    

    // Change password form  ######################################################################################################################
    var $changePasswordForm = $("#changePasswordForm");
    if ($changePasswordForm.length > 0) {
    	$changePasswordForm.validate({
	        rules: ele.validations.PasswordReset.rules,
	        messages: ele.validations.PasswordReset.messages,
	        errorElement: "div",
	        errorPlacement: function (h, l) {
	            h.appendTo(l.parent());
	        }
	    });
    }

    // Change password form LD ######################################################################################################################
    var $changePasswordForm = $("#e-user-password-form");
    if ($changePasswordForm.length > 0) {
    	$changePasswordForm.validate({
	        rules: ele.validations.PasswordReset.rules,
	        messages: ele.validations.PasswordReset.messages,
	        errorElement: "div",
	        errorPlacement: function (h, l) {
	            h.appendTo(l.parent());
	        }
	    });
    }


 // Customer Message Form/Contact   ***************************************************************************************************
	var $customerMessageForm = $(".e_customerMessageDetails #customerMessageForm");
	if ($customerMessageForm.length > 0) {
		var $customerMessageFormConfirm = $(".e_customerMessageDetails #confimationMessage");
		$customerMessageFormConfirm.hide();
		$customerMessageForm.validate({
			rules:ele.validations.customerMessage.rules,
			messages:ele.validations.customerMessage.messages,
			errorElement:"div",
			errorPlacement:function(error,element){
				element.parent("li").append(error);
			},
            invalidHandler: function(form, validator) {
                //this is for some reason called before errors are displayed, so force display
                var errors = validator.numberOfInvalids();
                if (errors) {
                    validator.showErrors();

                    //list of errors at the top of the screen.
                    $("#errorList").remove();
                    var errorDiv = $("<div id='errorList' class='error' tabindex=\"0\"></div>");
                    errorDiv.append("<h4>" + i18n('js_valid_title') + "</h4>");
                    for (var v in validator.invalid) {
                        if (!validator.invalid.hasOwnProperty(v)) {continue;}
                        //ids needed to link labels to fields
                        errorDiv.append("<p class='error-element-link'" + "data-element=" + v + ">"+validator.invalid[v].replace( "Error: ", "")+"</p>");
                    }
                    $customerMessageForm.prepend(errorDiv);
                    $('html, body').animate({
                        scrollTop: $("#errorList").offset().top - 20
                    }, 200, function() {
                        $("#errorList").focus();
                    });
                    $('.error-element-link').click(function(ev){
                        let elem = $(this).data('element');
                        $('html, body').animate({
                            scrollTop: $("[name='" + elem + "']").offset().top - 40
                        }, 200, function() {
                            $("#errorList").focus();
                        });
                    });
                }
            }
        });

		$customerMessageForm.submit(function(e){
            e.preventDefault();
            let responseMessage = document.getElementsByClassName('e_responseMessage');
            if (responseMessage.length > 0) { responseMessage[0].remove(); }
        
            if ($("#customerLoggedOut").length <= 0) {
                if ($(this).find(".e_serverValidationError").length > 0) {
                    var errorNotification = ele.notification('Please check the fields for errors before submitting the form', 'error');
                    $customerMessageForm.prepend(errorNotification);
                    return false;
                }
        
                if ($(this).valid()) {
                    ele.mouse.preventDoubleClickWithValidation("#contact-form-submit");
                    var loggedInEvent = $("#loggedInEvent").val();
                    var loggedOutEvent = $("#loggedOutEvent").val();
        
                    if (typeof grecaptcha !== 'undefined' && grecaptcha.execute) {
                        grecaptcha.execute(ele.config.reCaptcha.publicKey, {action: 'customerMessageForm'}).then(function(token) {
                            // Serialize form after receiving reCAPTCHA token
                            var form = $customerMessageForm,
                                customerData = form.serializeObject();
        
                            // Add reCAPTCHA token and action to serialized object
                            customerData['g-recaptcha-response'] = token;
                            customerData['g-recaptcha-action'] = 'customerMessageForm';
                
                            $.ajax({
                                type: 'POST',
                                url: ele.uri.buildUrl("customerMessageAdd"),
                                data: customerData,
                                success: function(response) {
                                    var JSONresponse = JSON.parse(response);
                                    if (JSONresponse.success) {
                                        $customerMessageForm.parent("#messageForm").fadeOut("fast");
                                        $customerMessageFormConfirm.fadeIn("fast");
                                        $("body").addClass('customerMessageSent');
                                    } else {
                                        if (JSONresponse.CAPTCHAERROR) {
                                            let errorNotification = ele.notification(JSONresponse.detail, 'error');
                                            $customerMessageForm.prepend(errorNotification);
                                            $('#captcha').addClass('error');
                                            responseMessage[0].scrollIntoView();
                                        } else {
                                            this.error();
                                        }
                                    }
                                },
                                error: function() {
                                    var errorNotification = ele.notification(i18n('js_contact_form_error'), 'error');
                                    $customerMessageForm.prepend(errorNotification);
                                    responseMessage[0].scrollIntoView();
                                }
                            });
                        });
                    } else {
                        console.warn('reCAPTCHA is not available.');
                    }
                }
        
                return false;
            }
        }).find(':input').bind('change', function() {
            $(this).parent().find('.e_serverValidationError').remove();
        });
        
	}

    var $customerMessageForm2023 = $(".e_customerMessageDetails #customerMessageForm2023");
	if ($customerMessageForm2023.length > 0) { 
		var $customerMessageForm2023Confirm = $(".e_customerMessageDetails #confimationMessage");
		$customerMessageForm2023Confirm.hide();
		$customerMessageForm2023.validate({
			rules: ele.validations.customerMessage.rules,
			messages:ele.validations.customerMessage.messages,
			errorElement:"div",
			errorPlacement:function(error,element){
				element.parent("div").append(error);
			},
            submitHandler: function(form) {            
                let responseMessage = document.getElementsByClassName('e_responseMessage');
                if (responseMessage.length > 0) {
                    responseMessage[0].remove();
                }
            
                const $form = $(form);
            
                if ($form.find(".e_serverValidationError").length > 0) {
                    const errorNotification = ele.notification('Please check the fields for errors before submitting the form', 'error');
                    $form.prepend(errorNotification);
                    return false;
                }
            
                ele.mouse.preventDoubleClickWithValidation("#contact-form-submit");
            
                const formData = $form.serializeObject();
            
                // Wait for reCAPTCHA before submitting
                if (typeof grecaptcha !== 'undefined' && grecaptcha.execute) {
                    grecaptcha.execute(ele.config.reCaptcha.publicKey, {
                        action: ele.config.reCaptcha.event
                    }).then(function (token) {
                        // Add reCAPTCHA data to formData
                        formData['g-recaptcha-response'] = token;
                        formData['g-recaptcha-action'] = ele.config.reCaptcha.event;
            
                        console.log(formData);
            
                        $.ajax({
                            type: 'POST',
                            url: ele.uri.buildUrl("customerMessageAdd"),
                            data: formData,
                            success: function (response) {
                                console.log(response);
                                let JSONresponse;
                                try {
                                    JSONresponse = JSON.parse(response);
                                } catch (e) {
                                    console.error("Invalid JSON in response", e);
                                    return;
                                }
            
                                if (JSONresponse.success) {
                                    $form.parent("#messageForm").fadeOut("fast");
                                    $customerMessageForm2023Confirm.fadeIn("fast");
                                    $("body").addClass('customerMessageSent');
                                } else {
                                    if (JSONresponse.CAPTCHAERROR) {
                                        const errorNotification = ele.notification(JSONresponse.detail, 'error');
                                        $form.prepend(errorNotification);
                                        $('#captcha').addClass('error');
                                        if (responseMessage.length > 0) responseMessage[0].scrollIntoView();
                                    } else {
                                        console.error("Unknown error:", JSONresponse);
                                    }
                                }
                            },
                            error: function () {
                                const errorNotification = ele.notification(i18n('js_contact_form_error'), 'error');
                                $form.prepend(errorNotification);
                                if (responseMessage.length > 0) responseMessage[0].scrollIntoView();
                            }
                        });
                    });
                } else {
                    const errorNotification = ele.notification('reCAPTCHA is not available. Please try again later.', 'error');
                    $form.prepend(errorNotification);
                }
            
                return false; // prevent default form submit
            },            
            invalidHandler: function(form, validator) {
                let responseMessage = document.getElementsByClassName('e_responseMessage');
                if(responseMessage.length > 0){ responseMessage[0].remove(); }                
                //this is for some reason called before errors are displayed, so force display
                var errors = validator.numberOfInvalids();
                if (errors) {
                    validator.showErrors();
                    //list of errors at the top of the screen.
                    $("#errorList").remove();
                    var errorDiv = $("<div id='errorList' class='error' tabindex=\"0\"></div>");
                    errorDiv.append("<h4>" + i18n('js_valid_title') + "</h4>");
                    for (var v in validator.invalid) {
                        if (!validator.invalid.hasOwnProperty(v)) {continue;}
                        //ids needed to link labels to fields
                        errorDiv.append("<p class='error-element-link'" + "data-element=" + v + ">"+validator.invalid[v].replace( "Error: ", "")+"</p>");
                    }
                    $customerMessageForm2023.prepend(errorDiv);
                    $('html, body').animate({
                        scrollTop: $("#errorList").offset().top - 20
                    }, 200, function() {
                        $("#errorList").focus();
                    });
                    $('.error-element-link').click(function(ev){
                        let elem = $(this).data('element');
                        $('html, body').animate({
                            scrollTop: $("[name='" + elem + "']").offset().top - 40
                        }, 200, function() {
                            $("#errorList").focus();
                        });
                    });
                }
            }
        });

        $customerMessageForm2023.find(':input').on('change',function(){
			// Remove server validation errors when input change
			$(this).parent().find('.e_serverValidationError').remove();
		});
	}

    // User (LawDraft) registration  ######################################################################################################################
    var $userRegistrationForm = $("#userregister");
    if ($userRegistrationForm.length > 0) {
        $userRegistrationForm.validate({
            rules: ele.validations.user.rules,
            messages: ele.validations.user.messages,
            errorPlacement: function(error, element) {
                error.appendTo(element.parents(".formGroup"));
            }
        });
    }

    // User (LawDraft) reset  ######################################################################################################################
    var $userRegistrationForm = $("#UserPasswordResetForm");
    if ($userRegistrationForm.length > 0) {
        $userRegistrationForm.validate({
            rules: ele.validations.user.rules,
            messages: ele.validations.user.messages,
            errorPlacement: function(error, element) {
                error.appendTo(element.parents(".formGroup"));
            }
        });
    }

    // User (LawDraft) password reminder validation  ######################################################################################################################
	$('document').ready(function() {
		if ($('#PasswordIdentityForm').length) {
			const $usernameField = $('#username');
			const $emailField = $('#useremail');

			function validateForm() {
				if ($usernameField.val().trim() === '' || $emailField.val().trim() === '') {
					$('#PasswordIdentityForm button').prop('disabled', true);
				} else {
					$('#PasswordIdentityForm button').prop('disabled', false);
				}
			}
			$usernameField.on('input', validateForm);
			$emailField.on('input', validateForm);
			validateForm();

            $("#PasswordIdentityForm").validate({
                rules: {
                    username:"required",
                    useremail:{required:true,email:true,maxlength:70}
                },
                messages: {
                    username: "Enter your username.",
                    useremail: {
                        required: 	"Please enter your email address",
                        email:		"Please enter a valid email address",
                        maxlength:	"Email address should be under 70 characters"
                    }
                },
                errorElement: "label",
                errorPlacement: function(error, element) {
                    error.insertAfter(element);
                }
            });
            
            $('#PasswordIdentityForm').submit(function(){
                if($('#PasswordIdentityForm').valid()){
                    $('#PasswordIdentityForm button').attr('disabled', 'disabled');
                }
            });
		}
	});



    //scheme form
    $("#schemeForm").validate({
        rules: {
            schemecode: {
                required: true
            }
        },
        messages: {
            schemecode: {
                required: i18n('js_valid_enter_scheme')
            }
        }
    });

});